import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  autoplay: "",
  loop: "",
  muted: "",
  ref: "video"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-video" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("video", _hoisted_1, _cache[0] || (_cache[0] = [
            _createElementVNode("source", {
              src: "video.mp4",
              type: "video/mp4"
            }, null, -1)
          ]), 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}